import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '@core/services/common-service/common.service';
import { EmployeeService } from '@core/services/employees/employee.service';
import { RequestService } from '@core/services/request-service/request.service';
import { GlobalConstants } from '@environments/global-Variables';
import { NewSystemAccessComponent } from '@shared/components/new-system-access/new-system-access.component';
import { RevokeSystemAccessComponent } from '@shared/components/revoke-system-access/revoke-system-access.component';
import { UpdateDetailModalComponent } from '@shared/components/update-detail-modal/update-detail-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'weaccess-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {

  globalConstants = GlobalConstants;

  bsModalRef!: BsModalRef;
  searchText: any;
  searchPlaceholder: any = "Enter minimum 3 character and hit enter";
  @Input() isEmployee!: boolean;
  @Input() searchType!: string;
  @Output() searchDataEvent = new EventEmitter<boolean>();
  searchDataSubscription!: Subscription;
  draftFilterListSubscription!: Subscription;
  personalDetailsSubscription!: Subscription;
  programDataSubscription!: Subscription;
  supervisorDataSubscription!: Subscription;
  programOptionsData: any;
  managerOptionsData: any;
  userRole: any;
  nonEmployeeFlag: boolean = false;

  constructor(
    private modalService: BsModalService,
    private employeeService: EmployeeService,
    private requestService: RequestService,
    private route: Router,
    private commonService: CommonService
  ) {
    this.userRole = localStorage.getItem(GlobalConstants?.USER_ROLE_KEY);
    this.userRole = JSON.parse(window.atob(this.userRole));
    if (this.userRole?.includes(this.globalConstants.ROLE_NON_EMPLOYEE)) {
      this.nonEmployeeFlag = true;
    }
  }

  /** Show Update Details Modal  */
  showUpdateDetailModal(): void {
    let personReqParam = {
      personId: 0
    }
    this.personalDetailsSubscription = this.commonService.getPersonalDetails(personReqParam).subscribe((data: any) => {
      this.getDropdownData(data);
    })
  }

  /** Open update detail modal functionality */
  openUpdateDetailModal(personData: any) {
    let optionDetailsData = {
      'programData': this.programOptionsData,
      'managerData': this.managerOptionsData
    }
    const modalData: any = {
      data: {
        'personFlag': 'false',
        'personData': personData,
        'pageType': 'search',
        'optionsDetailData': optionDetailsData
      }
    }
    this.bsModalRef = this.modalService.show(UpdateDetailModalComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-xl modal-dialog-centered',
      initialState: modalData
    });
  }

  /** Get dropdown options from API implementation */
  async getDropdownData(data: any) {
    let programReqParams = {
      departmentId: 0
    }
    this.programDataSubscription = await this.commonService.getProgramData(programReqParams).subscribe((programData: any) => {
      this.programOptionsData = programData;
      this.getSupervisorData(data);
    }, (error: any) => {
      this.getSupervisorData(data);
    });
  }

  /** Get supervisor options from API implementation */
  async getSupervisorData(data: any) {
    let managerReqParams = {
      departmentId: data?.departmentDetail?.departmentId
    }
    this.supervisorDataSubscription = await this.commonService.getSuperVisorData(managerReqParams).subscribe((supervisorData: any) => {
      this.managerOptionsData = supervisorData;
      this.openUpdateDetailModal(data);
    }, (error: any) => {
      this.openUpdateDetailModal(data);
    });
  }

  /** Show new system access modal */
  showNewRequestAccessModal(): void {
    const modalData: any = {
      data: {
        'personFlag': 'false',
        'personData': '',
      }
    }
    this.bsModalRef = this.modalService.show(NewSystemAccessComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-xl modal-dialog-centered',
      initialState: modalData
    });
  }

  /** Show revoke System Access Modal */
  showRevokeRequestAccessModal(): void {
    const modalData: any = {
      data: {
        'personFlag': 'false',
        'personData': '',
      }
    }
    this.bsModalRef = this.modalService.show(RevokeSystemAccessComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-xl modal-dialog-centered',
      initialState: modalData
    });
  }

  /** Search employee emit event functionality implementation */
  searchEmployees(searchValue: any, event: any) {
    let validateKey = this.getKeyCodeValidation(event.keyCode);
    if (searchValue?.length >= 3) {
      searchValue = searchValue?.trim();
    }
    if (validateKey) {
      if (searchValue?.length === 0) {
        this.searchText = null;
        let searchResult: any = { searchData: '' };
        this.searchDataEvent.emit(searchResult);
      } else {
        if (searchValue?.length >= 3) {
          if (this.searchType === 'staff' || this.searchType === 'department' || this.searchType === 'person') {
            let searchResult: any = { searchData: searchValue };
            this.searchDataEvent.emit(searchResult);
          } else if (this.searchType === 'submitted' || this.searchType === 'processed' || this.searchType === 'returned' || this.searchType === 'pendingApproval' || this.searchType === 'draft') {
            let searchResult: any = { searchData: searchValue, searchText: searchValue }
            this.searchDataEvent.emit(searchResult);
          }
        }
      }
    }
  }

  /** Search field keycode enter validation for invalid characters */
  getKeyCodeValidation(keyCode: any) {
    if (keyCode === 8 || keyCode === 13 || keyCode === 32 || (keyCode > 47 && keyCode < 91) || (keyCode > 94 && keyCode < 106)) {
      return true;
    } else {
      return false
    }
  }

  /** Search field length validation */
  SearchValidation(searchValue: any): any {
    if (searchValue?.length >= 3) {
      this.searchPlaceholder = "Please press enter to see results";
    } else if (searchValue?.length > 0 || searchValue?.length < 3) {
      this.searchPlaceholder = "Please enter minimum 3 character and press enter to search";
    }
  }

  /** Open new request functionality */
  openNewRequest() {
    this.commonService.setNonEmployeeReqState('New');
    this.route.navigate(['/non-employee-request']);
  }

}
